import React from 'react';
import { LogoMark } from './LogoMark';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Renders either the default Magic Forest logo or a custom uploaded logo.
 * Used by all template layouts.
 *
 * @param {Object} props
 * @param {string} [props.className] - Size/color classes (e.g. 'h-20 w-20 text-white/90')
 * @param {Object} [props.style] - Additional inline styles
 * @param {string} [props.logoUrl] - Custom logo URL (null = default Magic Forest logo)
 * @param {number} [props.size] - Logo size in pixels (overrides className dimensions)
 * @param {boolean} [props.isDark] - If true, invert logo colors (dark→white) for visibility
 */
export function SlideLogo({ className = 'h-20 w-20', style = {}, logoUrl = null, size = null, isDark = false }) {
  // If explicit size is set, apply as inline width/height (overrides Tailwind classes)
  const sizeStyle = size ? { width: size, height: size } : {};
  // If logo is dark, invert to make it visible on dark backgrounds
  const invertStyle = (isDark && logoUrl) ? { filter: 'invert(1) brightness(2)' } : {};
  const mergedStyle = { ...style, ...sizeStyle, ...invertStyle };

  if (logoUrl) {
    // Custom uploaded logo
    const src = logoUrl.startsWith('http') ? logoUrl : `${BACKEND_URL}${logoUrl}`;
    return (
      <img
        src={src}
        alt="Logo"
        className={className}
        style={{ objectFit: 'contain', ...mergedStyle }}
      />
    );
  }

  // Default Magic Forest logo
  return <LogoMark className={className} style={mergedStyle} />;
}
